import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaqQa } from '../../components/faq-qa/faq-qa';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-faq',
  imports: [RouterLink, FaqQa],
  templateUrl: './faq.html',
  styleUrl: './faq.scss',
})
export class Faq implements OnInit {
  private readonly commonService = inject(CommonService);

  ngOnInit(): void {
    this.commonService.showTitle('/assets/titles/faq.jpg');
  }
}
